module.exports = __webpack_public_path__ + "img/Teegeschütte.0531c15e.svg";